import { useEffect, useState } from "react";
import Sun from "./SVGIcons/Sun";
import Moon from "./SVGIcons/Moon";
import { useAppContext } from "../hooks/useAppContext";

const ThemeSlider = () => {
  const { theme, setTheme } = useAppContext();

  const themes = [
    { id: "light", label: "Light", icon: <Sun className="size-4" /> },
    { id: "dark", label: "Dark", icon: <Moon className="size-4" /> },
  ];

  const getSliderPosition = () => {
    const index = themes.findIndex((t) => t.id === theme);
    return `translateX(${index * 100}%)`;
  };

  useEffect(() => {
    // Initialize theme from localStorage or default to light
    const storedTheme = localStorage.getItem("theme") || "light";

    setTheme(storedTheme);
    document.documentElement.setAttribute("data-theme", storedTheme);
  }, []);

  return (
    <div className="relative h-full w-40 rounded-[30px] bg-grayscale-opacity-blevel1 p-1">
      {/* Sliding indicator */}
      <div
        className="absolute top-[3px] h-[calc(100%-7px)] w-[calc(50%-4px)] rounded-[30px] bg-blue-solid-blue6 transition-transform duration-300 ease-out"
        style={{ transform: getSliderPosition() }}
      />

      {/* Theme buttons */}
      <div className="relative flex h-full items-center justify-center">
        {themes.map((t) => {
          const icon = t.icon;
          const isActive = theme === t.id;

          return (
            <button
              key={t.id}
              onClick={() => {
                setTheme(t.id);
                localStorage.setItem("theme", t.id);
                document.documentElement.setAttribute("data-theme", t.id);
              }}
              className={`relative z-10 flex h-6 w-full items-center justify-center gap-2 rounded-[30px] px-4 transition-all duration-300 ease-out ${
                isActive ? "fill-white" : "fill-grayscale-solid-g7"
              } `}
            >
              {icon}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeSlider;
